module.exports = __webpack_public_path__ + "mv.8f866c7776b23f9c12dd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mv.svg
// module chunks = styles